import syncTimerWithServerTime from '@/api/interceptors/serverTime.response.interceptor';
import axios, { AxiosResponse } from 'axios';

const client = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
});

client.interceptors.response.use(serverTimeOnFulfilled, serverTimeOnRejected);

function serverTimeOnFulfilled(response: AxiosResponse) {
  syncTimerWithServerTime(response);

  return response;
}

function serverTimeOnRejected(error: any) {
  if (error.response) {
    syncTimerWithServerTime(error.response);
  }

  return Promise.reject(error);
}

export default client;
